import { EntityAction, EntityActionContributorCallback } from '@abp/ng.components/extensible';
import { IdentityUserDto } from '@abp/ng.identity/proxy';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ImpersonationConsentDialogComponent } from '../shared/impersonation/impersonation-consent-dialog.component';
import { ImpersonationService } from '../shared/impersonation/impersonation.service';

/**
 * Adds "Login as user" to the row actions on the built-in Identity users page, mirroring where ABP
 * Commercial's Account Pro module put it.
 *
 * The action is hidden — not disabled — on rows the backend would reject (administrators, and
 * legacy rows whose UserType predates the column). `ImpersonationService.canImpersonate` answers
 * from a list fetched once per page load and returns false until it arrives, so the action never
 * appears on a row that cannot be used.
 */
const loginAsUserContributor: EntityActionContributorCallback<IdentityUserDto> = actionList => {
  actionList.addTail(
    EntityAction.create<IdentityUserDto>({
      text: '::LoginAsUser',
      icon: 'fa fa-user-secret',
      permission: 'ReturnLy.Users.Impersonate',
      visible: data => data.getInjected(ImpersonationService).canImpersonate(data.record?.id),
      action: data => {
        const record = data.record;

        // A dialog rather than a confirm: signing in as someone now requires a code that only they
        // receive, so there is a conversation to conduct here, not a decision to confirm.
        const modal = data
          .getInjected(NgbModal)
          .open(ImpersonationConsentDialogComponent, { backdrop: 'static', centered: true });

        modal.componentInstance.userId = record.id;
        modal.componentInstance.userName =
          record.name || record.userName || record.email || '';

        // The dialog navigates away on success and reports its own failures, so nothing is done
        // with the result. Dismissal is a normal outcome and must not surface as an error.
        modal.result.catch(() => undefined);
      },
    })
  );
};

export const IDENTITY_ENTITY_ACTION_CONTRIBUTORS = {
  'Identity.UsersComponent': [loginAsUserContributor],
};
